import React, { useState } from 'react';
import { T } from '../shared/constants';
import { ItemFrame, Instruction, CheckButton, ResultCard } from './ItemChrome';
import { buildStudentAnswer, isCorrectResponse, feedbackFor } from './naplanItems';

/** `short` — type a number or a word. Response: the typed string. */
export default function ShortRenderer({ question, studentAnswer, state, showExplanation, onSubmit, onAskLumi, onExplainVideo }) {
  const isAnswered = studentAnswer != null;
  const [draft, setDraft] = useState('');
  const value = isAnswered ? String(studentAnswer.rawAnswer ?? '') : draft;
  const isCorrect = isAnswered ? (typeof studentAnswer.isCorrect === 'boolean' ? studentAnswer.isCorrect : isCorrectResponse(question, value)) : false;
  const empty = draft.trim() === '';

  function submit() {
    if (isAnswered || empty) return;
    onSubmit(buildStudentAnswer(question, draft.trim()));
  }

  const border = isAnswered ? (isCorrect ? T.green : T.red) : T.border;
  return (
    <ItemFrame question={question} state={state} isAnswered={isAnswered}>
      <Instruction>{question.numeric ? 'Type your answer as a number' : 'Type your answer'}</Instruction>
      <form
        onSubmit={e => { e.preventDefault(); submit(); }}
        style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 20, flexWrap: "wrap" }}
      >
        <input
          type="text"
          aria-label="Your answer"
          value={value}
          readOnly={isAnswered}
          aria-invalid={isAnswered && !isCorrect ? true : undefined}
          onChange={e => setDraft(e.target.value)}
          inputMode={question.numeric ? "decimal" : "text"}
          autoComplete="off" autoCorrect="off" autoCapitalize="off" spellCheck={false}
          style={{
            flex: "1 1 160px", maxWidth: 320, padding: "14px 16px", borderRadius: 12,
            border: `1.5px solid ${border}`, background: isAnswered ? (isCorrect ? T.greenLo : T.redLo) : T.card,
            color: isAnswered ? (isCorrect ? T.green : T.red) : T.text, fontSize: 17, fontWeight: 600,
            fontFamily: "'Plus Jakarta Sans', sans-serif", outline: "none", boxSizing: "border-box",
          }}
        />
        {question.unit && <span style={{ fontSize: 16, fontWeight: 600, color: T.textMid }}>{question.unit}</span>}
        {isAnswered && <span aria-hidden="true" style={{ fontSize: 18, fontWeight: 800, color: isCorrect ? T.green : T.red }}>{isCorrect ? '✓' : '✗'}</span>}
      </form>
      {!isAnswered && <CheckButton mode={state.mode} disabled={empty} onClick={submit} />}
      <ResultCard
        question={question} mode={state.mode} isAnswered={isAnswered} isCorrect={isCorrect}
        showExplanation={showExplanation} feedback={isAnswered && !isCorrect ? feedbackFor(question, value) : null}
        onAskLumi={onAskLumi} onExplainVideo={onExplainVideo}
      />
    </ItemFrame>
  );
}
